import { Directive } from '@angular/core';

@Directive({
  selector: '[fEmptyStatesActions]'
})
export class FireflyEmptyStatesDirective {}
